import { MerchantDetail } from 'lib/shop/types';
import Image from 'next/image';
import Facebook from 'public/icons/facebook.png';
import Instagram from 'public/icons/instagram.png';
import Website from 'public/icons/website.png';
import React from 'react';

export default function MerchantMoreInfo({
  merchant,
}: {
  merchant: MerchantDetail;
}) {
  return (
    <>
      {(merchant.website_url ||
        merchant.instagram_url ||
        merchant.facebook_url) && (
        <div>
          <div className="my-2">
            <h3>More info</h3>
          </div>
          <div className="my-4 space-y-2 pb-4">
            {merchant.website_url && (
              <a
                href={merchant.website_url}
                rel="noreferrer noopener nofollow"
                target="_blank"
                className="flex gap-3 py-3"
              >
                <div className="relative h-6 w-6">
                  <Image alt="Website" src={Website} width={24} height={24} />
                </div>
                <div className="h7 text-green-500">
                  {merchant.website_url_label || 'Website'}
                </div>
              </a>
            )}
            {merchant.instagram_url && (
              <a
                href={merchant.instagram_url}
                rel="noreferrer noopener nofollow"
                target="_blank"
                className="flex gap-3 py-3"
              >
                <div className="relative h-6 w-6">
                  <Image
                    alt="Instagram"
                    src={Instagram}
                    width={24}
                    height={24}
                  />
                </div>
                <div className="h7 text-green-500">
                  {merchant.instagram_url_label ?? 'Instagram'}
                </div>
              </a>
            )}
            {merchant.facebook_url && (
              <a
                href={merchant.facebook_url}
                rel="noreferrer noopener nofollow"
                target="_blank"
                className="flex gap-3 py-3"
              >
                <div className="relative h-6 w-6">
                  <Image alt="Facebook" src={Facebook} width={24} height={24} />
                </div>
                <div className="h7 text-green-500">
                  {merchant.facebook_url_label ?? 'Facebook'}
                </div>
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
}
